import { fetchGetUserInfo } from '@/service/api';
import { localStg } from '@/utils/storage';

/** Get token */
export function getToken() {
  return localStg.get('token') || '';
}

type RawUserInfo = Partial<Api.Auth.UserInfo> & {
  id?: string;
};

/** 归一化 getUserInfo 响应，兼容 id/userId 及 stat 权限字段为 null 的情况 */
export function normalizeUserInfo(raw: RawUserInfo = {}): Api.Auth.UserInfo {
  return {
    userId: raw.userId || raw.id || '',
    userName: raw.userName ?? '',
    roles: raw.roles ?? [],
    buttons: raw.buttons ?? [],
    gender: raw.gender ?? 0,
    nickName: raw.nickName ?? '',
    phonenumber: raw.phonenumber ?? '',
    email: raw.email ?? '',
    dataSourcePref: raw.dataSourcePref ?? null,
    adjustToken: raw.adjustToken ?? null,
    adjustTokenConfigured: raw.adjustTokenConfigured ?? null,
    appStatPerms: raw.appStatPerms ?? [],
    channelStatPerms: raw.channelStatPerms ?? [],
    financeStatPerm: raw.financeStatPerm ?? 0
  };
}

/** Get user info */
export function getUserInfo() {
  const stored = localStg.get('userInfo');
  return normalizeUserInfo(stored ?? {});
}

/** Clear auth storage */
export function clearAuthStorage() {
  localStg.remove('token');
  localStg.remove('refreshToken');
  localStg.remove('userInfo');
}

/** 从服务端拉取用户信息并写入 localStorage（应用启动 / 登录复用） */
export async function refreshUserInfoFromServer(): Promise<Api.Auth.UserInfo | null> {
  if (!getToken()) {
    return null;
  }

  const { data: info, error } = await fetchGetUserInfo();

  if (!error && info) {
    const normalized = normalizeUserInfo(info);
    localStg.set('userInfo', normalized);
    return normalized;
  }

  if (error?.response?.status === 401) {
    clearAuthStorage();
  }

  return null;
}
